module.exports = __webpack_public_path__ + "img/page_bg.25117307.png";